<!--首页，根据不同情况选择不同登录页-->
<template>
	<login v-if="loginType==0"></login>
	<!--<huanbaoLogin v-else-if='loginType==1'></huanbaoLogin>-->
	<demoSystemLogin v-else-if='loginType==2'></demoSystemLogin>
	<jspLogin v-else></jspLogin>
</template>
<script type="text/javascript">
	import login from '@/page/login.vue'
	import demoSystemLogin from '@/page/demoSystem/demoSystemLogin.vue'
	import jspLogin from '@/page/demoSystem/jspLogin.vue'
	/*import huanbaoLogin from '@/page/system/huanbaoyongdiang/login.vue'*/
	export default {
		components: {
			login,
			demoSystemLogin,
			jspLogin,
			/*huanbaoLogin,*/
		},
		props: [],
		data() {
			return {
				loginType: 0
			}
		},
		created() {
			if (DWSystemSetting.hasOwnProperty('loginType')) {
				this.loginType = DWSystemSetting.loginType
			}
		},
		mounted() {
		},
		destroyed() {},
		computed: {
		},
		watch: {
		},
		methods: {
		}
	}
</script>

<style scoped>
	.loginContent input:-webkit-autofill {
		-webkit-box-shadow: 0 0 0px 1000px white inset;
		height: 27px !important;
		line-height: 27px !important;
		border-radius: 0 4px 4px 0;
	}

	.unitTitle {
		margin-top: 5%;
		margin-left: 5%;
		margin-bottom: 3%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		min-width: 500px;
		z-index: 1;
	}

	.errorMsg {
		display: flex;
		align-items: center;
		width: 89%;
		margin-left: 5px;
		margin-top: 15px;
	}

	.loginText {
		margin-top: 20px;
		border: 1px solid #d6d6d6;
		padding: 2%;
		width: 85%;
		border-radius: 5px;
	}

	.loginText img {
		width: 20px;
		height: 20px;
	}

	.loginText input {
		outline: none;
		width: calc(100% - 25px);
		height: 27px !important;
		line-height: 27px !important;
		font-size: 16px;
		margin-left: 5px;
	}

	.loginButton {
		cursor: pointer;
		margin-top: 20px;
		font-size: 20px;
		width: 89%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.loginTitle {
		width: 89%;
		font-size: 30px;
		line-height: 35px;
	}

	.cnTitle {
		font-size: 36px;
		letter-spacing: 13px;
	}

	.loginBody {
		min-width: 1366px;
		width: 100%;
		height: 100%;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex !important;
		justify-content: space-between !important;
	}

	.loginContent {
		width: 350px;
		background-color: rgba(255, 255, 255, 0.5);
		display: flex;
		flex-direction: column;
		align-items: center;
		position: absolute;
		top: 12%;
		right: 20px;
		padding: 30px;
		border-radius: 10px;
	}

	.videoBg {
		background: white;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;
		overflow: hidden;
	}

	.videoPlayer {
		width: 100%;
	}

	.qrcode {
		display: inline-flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		margin-right: 40px;
	}

	.qrcode>img {
		width: 100px;
		height: 100px;
	}

	.qrcode>p {
		color: white;
		text-align: center;
	}

	.information {
		position: absolute;
		z-index: 1;
		bottom: 20px;
		left: calc(50% - 100px);
	}

	.information>p {
		color: #bbb;
		font-size: 14px;
		text-align: center;
	}
</style>
